import { AvatarVO } from "./AvatarVO";

export class AvatarCardVO {
    public id: number = 0;
    public name: string;
    public rank: number = 0;
    public level: number = 0;
    public xp: number = NaN;
    public chips: number = NaN;
    public gender: string;
    public items: string;
    public avatar: AvatarVO;
}
